module.exports = __webpack_public_path__ + "img/regular_loan_overview_icon03.6038519d.svg";